import { Grow as MuiGrow, type GrowProps as MuiGrowProps } from '@mui/material';
import { forwardRef, type CSSProperties, type PropsWithChildren } from 'react';

type Props = Pick<MuiGrowProps, 'in' | 'timeout' | 'children'> & {
  from?: CSSProperties['transformOrigin'];
};

export const Grow = forwardRef<unknown, PropsWithChildren<Props>>(
  ({ children, from, ...rest }, ref) => {
    return (
      <MuiGrow style={{ transformOrigin: from }} {...rest} ref={ref}>
        {children}
      </MuiGrow>
    );
  },
);
